import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Image } from "../../assets/images/briefDetails.svg";

export const LockCard = ({ activeTab, isLoggedIn, token, companyID, paynow }) => {
  return (
    <div className="text-center flex flex-col items-center">
      <Image />
      <h3 className="text-secondarytwo text-left text-f20 font-semibold">
        Unlock Brief {activeTab === 2 ? "Details" : "Documents"}
      </h3>
      <p className="text-secondary pb-4">
        Pay a premium & get claim to all of the details
      </p>
      <hr />

      <Link
        to="#"
        onClick={() => paynow()}
        className="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
      >
        Pay Now
      </Link>
      {!isLoggedIn && <div className="flex justify-between text-secondary pt-4 items-center">
        <p>
          Already have an account?{" "}
          <Link className="text-primaryText font-semibold" to={"/login"}>
            Login
          </Link>
        </p>
      </div>}
    </div>
  );
};
